import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appEmbedData = { image: '_media' };
var _audioData = { audio: '_media', coverImage: '_media' };
var _background = { image: '_media' };
var _bulkMachineTranslateRequest = {
    contentToTranslate: '_translatableContent',
};
var _bulkMachineTranslateResponse = { results: '_bulkTranslateResult' };
var _bulkTranslateResult = { item: '_translatableContent' };
var _design = { poll: '_pollDesign' };
var _galleryData = { items: '_item', options: '_galleryOptions' };
var _galleryOptions = { item: '_itemStyle' };
var _image = { media: '_media' };
var _imageData = { image: '_media' };
var _item = { image: '_image', video: '_video' };
var _itemStyle = { ratio: 'google.protobuf.DoubleValue' };
var _machineTranslateRequest = { contentToTranslate: '_translatableContent' };
var _machineTranslateResponse = { translatedContent: '_translatableContent' };
var _mapData = { mapSettings: '_mapSettings' };
var _mapSettings = {
    lat: 'google.protobuf.DoubleValue',
    lng: 'google.protobuf.DoubleValue',
};
var _media = { duration: 'google.protobuf.DoubleValue' };
var _metadata = {
    createdTimestamp: 'google.protobuf.Timestamp',
    updatedTimestamp: 'google.protobuf.Timestamp',
};
var _node = {
    galleryData: '_galleryData',
    imageData: '_imageData',
    mapData: '_mapData',
    pollData: '_pollData',
    appEmbedData: '_appEmbedData',
    videoData: '_videoData',
    audioData: '_audioData',
    nodes: '_node',
};
var _option = { image: '_media' };
var _poll = { image: '_media', options: '_option' };
var _pollData = { poll: '_poll', design: '_design' };
var _pollDesign = { background: '_background' };
var _richContent = { nodes: '_node', metadata: '_metadata' };
var _translatableContent = { richContent: '_richContent' };
var _video = { media: '_media', thumbnail: '_media' };
var _videoData = { video: '_media', thumbnail: '_media' };
function resolveWixMultilingualMachineV3MachineTranslationUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/machine-translation/v3',
                destPath: '/v3',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/machine-translation/v3',
                destPath: '/v3',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/machine-translation/v3',
                destPath: '/v3',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/machine-translation/v3',
                destPath: '/v3',
            },
        ],
        _: [
            {
                srcPath: '/_api/machine-translation/v3',
                destPath: '/v3',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/machine-translation/v3',
                destPath: '/v3',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/machine-translation/v3',
                destPath: '/v3',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/machine-translation/v3',
                destPath: '/v3',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Translates the text of a translatable unit of content from one supported language to another.
 *
 * The `translatedContent` object returns with the same `id` used for `contentToTranslate.id` but the text within the
 * content fields is replaced with the translated text. Note that Wix does not overwrite the original content object.
 * To retrieve the translated content later, make sure to store it separately.
 *
 * Only text content is translated, even if the content is `htmlContent` or `richContent`. Note that [collapsible text](https://support.wix.com/en/article/adding-and-setting-up-collapsible-text)
 * cannot be translated using this method.
 *
 * The translatable content must not exceed 5,000 characters. If this limit is exceeded, the method returns a `TEXT_TOO_LONG` error.
 * For `richContent`, the 5,000-character limit applies separately to each node in `richContent.nodes`.
 * The total translatable content may be more than 5,000 characters as long as no individual node surpasses this limit.
 * If any node exceeds 5,000 characters, the entire request fails.
 *
 * Each site has a [word credit](/machine-translation/introduction#terminology) balance, starting at 3,000 words.
 * Each successful translation request reduces the word credits by the number of words in `contentToTranslate`.
 * If the site does not have sufficient word credits to translate all of the text in the request, the request fails
 * with a `NOT_ENOUGH_CREDITS` error. Additional credits can be [purchased through the Dashboard](https://support.wix.com/en/article/wix-multilingual-auto-translating-your-site?tabs=Dashboard-5#purchasing-translation-packages).
 *
 * To translate up to 1,000 `translatableContent` units at once, use [Bulk Machine Translate](/machine-translation/bulk-machine-translate).
 */
export function machineTranslate(payload) {
    var _a = serializer(_machineTranslateRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _translatableContent: _translatableContent,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_machineTranslateResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _translatableContent: _translatableContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __machineTranslate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.machine.v3.translatable_content',
            method: 'POST',
            methodFqn: 'wix.multilingual.machine.v3.MachineTranslation.MachineTranslate',
            url: resolveWixMultilingualMachineV3MachineTranslationUrl({
                protoPath: '/v3/machine-translate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __machineTranslate.fromReq = fromReq;
    __machineTranslate.__isAmbassador = true;
    return __machineTranslate;
}
/**
 * Translates the text of multiple units of translatable content from one supported language to another.
 *
 * Each translated content item in the `results` array returns with the same `id` as the corresponding `contentToTranslate.id`, but with the text in the
 * content fields replaced with the translated text. Note that Wix does not overwrite the original content source,
 * to retrieve the translated content later, make sure to store it separately.
 *
 * Only text content is translated, even if the content is `htmlContent` or `richContent`. Note that [collapsible text](https://support.wix.com/en/article/adding-and-setting-up-collapsible-text)
 * cannot be translated using this method.
 *
 * Each unit of translatable content must not exceed 5,000 characters. If this limit is exceeded, the method returns a `TEXT_TOO_LONG` error.
 * For `richContent`, the 5,000-character limit applies separately to each node in `richContent.nodes`.
 * The total request may exceed 5,000 characters as long as no individual node surpasses this limit.
 * If any node exceeds 5,000 characters, then the request fails for that specific `contentToTranslate` item and the error details for that
 * error are returned in `itemMetadata`. Even if some translations fail due to the character limit,
 * the machine translation for other items will succeed if they are under the character limit.
 *
 * Each site has a [word credit](/machine-translation/introduction#terminology) balance, starting at 3,000 words.
 * Each successful translation request reduces the word credits by the number of words included in `contentToTranslate`.
 * If the site does not have sufficient word credits to complete the translation, then the entire request fails
 * with a `NOT_ENOUGH_CREDITS` error. Additional credits can be [purchased through the Dashboard](https://support.wix.com/en/article/wix-multilingual-auto-translating-your-site?tabs=Dashboard-5#purchasing-translation-packages).
 *
 * To translate a single unit of `translatableContent`, use [Machine Translate](/machine-translation/machine-translate).
 */
export function bulkMachineTranslate(payload) {
    var _a = serializer(_bulkMachineTranslateRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _translatableContent: _translatableContent,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkMachineTranslateResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _bulkTranslateResult: _bulkTranslateResult,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _translatableContent: _translatableContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __bulkMachineTranslate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.machine.v3.translatable_content',
            method: 'POST',
            methodFqn: 'wix.multilingual.machine.v3.MachineTranslation.BulkMachineTranslate',
            url: resolveWixMultilingualMachineV3MachineTranslationUrl({
                protoPath: '/v3/bulk-machine-translate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkMachineTranslate.fromReq = fromReq;
    __bulkMachineTranslate.__isAmbassador = true;
    return __bulkMachineTranslate;
}
//# sourceMappingURL=http.impl.js.map